import UserRepository from './UserRepository';

const repositories = {
    login: UserRepository,
    // drugi repos
};

export enum RepositoryTypes {
    Login = 'login',
}

export const RepositoryFactory = {
    get : (name: RepositoryTypes) => (repositories as any)[name.valueOf()],
};
